import * as yup from 'yup';
yup.setLocale({
  mixed: {
    required: ({ label }) => {
      return `請輸入${label}`;
    }
  },
  string: {
    min: '長度至少${min}個字元',
    max: '長度最多${max}個字元',
    email: '請輸入合法電子郵件',
  }
});
const pwdRule = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).*$/;
export const useValidationSchema = {
  loginSchema(){ 
    const schema = yup.object({
      email: yup.string().label("電子郵件").required().max(100).email(),
      pwd: yup.string().label("密碼").required().min(8).max(20)
        .matches(pwdRule, '至少含一個大寫與小寫字母、數字、特殊符號'),
    });
    return schema;
  },
  regiserSchema() {
    const schema = yup.object({
      name: yup.string().label("名稱").required().min(2).max(20),
      email: yup.string().label("電子郵件").required().max(100).email(),
      pwd: yup.string().label("密碼").required().min(8).max(20)
        .matches(pwdRule, '至少含一個大寫與小寫字母、數字、特殊符號'),
    });
    return schema;
  }
}